import React, { type ReactNode } from 'react';

import { DOMAIN, REASON, reportError } from '~/services/telemetry';

type Props = {
  parent?: string;
  children: ReactNode;
};

interface Error {
  stack?: string;
}

export default class CarouselErrorBoundary extends React.Component<
  Props,
  { hasError: boolean }
> {
  children: ReactNode;
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Обновить состояние с тем, чтобы следующий рендер показал запасной UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Both the error and the component stack used to be interpolated into the
    // title, which made every occurrence its own issue.
    reportError(DOMAIN.ui, error, {
      reason: REASON.ui.carouselRenderFailed,
      // `parent` alone resolved to `window.parent`, so every carousel failure
      // was titled with a Window object rather than the block that broke.
      fingerprint: [this.props.parent ?? 'unknown'],
      extras: { parent: this.props.parent ?? 'unknown', errorInfo },
    });
    // Можно также сохранить информацию об ошибке в соответствующую службу журнала ошибок
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Можно отрендерить запасной UI произвольного вида
      return null;
    }

    return this.props.children;
  }
}
